import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

// 解决vue项目路由出现message: "Navigating to current location (XXX) is not allowed"的问题
const routerPush = Router.prototype.push
Router.prototype.push = function push (location) {
  return routerPush.call(this, location).catch(error => error)
}

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      redirect: '/index'
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/Login')
    },
    {
      path: '/page',
      name: 'page',
      redirect: '/index',
      component: () => import('@/views/Container'),
      children: [
        {
          path: '/index',
          name: 'index',
          meta: {
            requireAuth: true,
            title: '首页',
            name: 'index',
            id: '1'
          },
          component: () => import('@/views/Home/index')
        },
        {
          path: '/knowledge',
          name: 'knowledge',
          redirect: '/knowledge/index',
          meta: {
            requireAuth: true,
            title: '知识点精讲',
            name: 'knowledge',
            id: '2'
          },
          component: () => import('@/views/Knowledge/index'),
          children: [
            {
              path: '/knowledge/index',
              name: 'knowledgeIndex',
              meta: {
                requireAuth: true,
                title: '知识点精讲',
                name: 'knowledge',
                id: '2'
              },
              component: () => import('@/views/Knowledge/index')
            }
          ]
        },
        {
          path: '/exam',
          name: 'exam',
          redirect: '/exam/index',
          meta: {
            requireAuth: true,
            title: '中学题库',
            name: 'exam',
            id: '3'
          },
          component: () => import('@/views/Exam/index'),
          children: [
            {
              path: '/exam/index',
              name: 'examIndex',
              meta: {
                requireAuth: true,
                title: '中学题库',
                name: 'exam',
                id: '3'
              },
              component: () => import('@/views/Exam/index')
            }
          ]
        },
        {
          path: '/video',
          name: 'video',
          redirect: '/video/index',
          meta: {
            requireAuth: true,
            title: '升学课堂',
            name: 'video',
            id: '4'
          },
          component: () => import('@/views/Video/index'),
          children: [
            {
              path: '/video/index',
              name: 'videoIndex',
              meta: {
                requireAuth: true,
                title: '升学课堂',
                name: 'video',
                id: '4'
              },
              component: () => import('@/views/Video/content/index')
            },
            {
              path: '/video/detail',
              name: 'videoDetail',
              meta: {
                requireAuth: true,
                title: '升学课堂',
                name: 'video',
                id: '4'
              },
              component: () => import('@/views/Video/content/detail')
            }
          ]
        },
        {
          path: '/personal',
          name: 'personal',
          redirect: '/personal/index',
          meta: {
            requireAuth: true,
            title: '个人中心',
            name: 'personal',
            id: '5'
          },
          component: () => import('@/views/Personal/index'),
          children: [
            {
              path: '/personal/index',
              name: 'personalIndex',
              meta: {
                requireAuth: true,
                title: '基本信息',
                name: 'personal',
                id: '5'
              },
              component: () => import('@/views/Personal/content/index')
            },
            {
              path: '/personal/video',
              name: 'personalVideo',
              meta: {
                requireAuth: true,
                title: '观看记录',
                name: 'personal',
                id: '5'
              },
              component: () => import('@/views/Personal/content/video')
            },
            {
              path: '/personal/collection',
              name: 'personalCollection',
              meta: {
                requireAuth: true,
                title: '我的收藏',
                name: 'personal',
                id: '5'
              },
              component: () => import('@/views/Personal/content/collection')
            },
            {
              path: '/personal/order',
              name: 'personalOrder',
              meta: {
                requireAuth: true,
                title: '订单中心',
                name: 'personal',
                id: '5'
              },
              component: () => import('@/views/Personal/content/order')
            },
            {
              path: '/personal/safety',
              name: 'personalSafety',
              meta: {
                requireAuth: true,
                title: '安全中心',
                name: 'personal',
                id: '5'
              },
              component: () => import('@/views/Personal/content/safety')
            }
          ]
        },
      ]
    }
  ]
})

router.beforeEach((to, from, next) => {
  // cookie中是否有token
  if (document.cookie.indexOf('courseauth') !== -1) {
    // 存在token，继续跳转到要去的路由
    next()
  } else {
    // 不存在token
    if (to.meta.requireAuth) { // 页面是否需要token
      // 需要token，跳转到登录页面
      next({
        path: '/login'
      })
    } else {
      // 不需要token，继续跳转到要去的路由
      next()
    }
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js